export { Tooltiped } from './ui/Tooltiped';
export type { TooltipPosition } from './ui/Tooltiped';
